import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import store, { persistor } from "./redux/store";
import { Provider } from "react-redux";
import LoadingProvider from "./base/context/LoaderProvider";
import MessageProvider from "./base/context/MessageProvider";
import OutsideClickProvider from "./base/context/OutsideClick";
import SubscriptionProgressProvider from "./base/context/SubscriptionProgressProvider";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <GoogleOAuthProvider clientId="7018459595-k5eeb3t60q1l0kerk7if33fdbnq5efnt.apps.googleusercontent.com">
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <MessageProvider>
          <LoadingProvider>
            <SubscriptionProgressProvider>
              <OutsideClickProvider>
                <App />
              </OutsideClickProvider>
            </SubscriptionProgressProvider>
          </LoadingProvider>
        </MessageProvider>
      </PersistGate>
    </Provider>
  </GoogleOAuthProvider>
);
